import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'app-project-settings',
  templateUrl: './settings.component.html',
  styleUrls: ['./settings.component.scss']
})
export class SettingsComponent implements OnInit {
  @Input() project;
  constructor() {}

  ngOnInit(): void {
  }

}

